module.exports = __webpack_public_path__ + "img/Surgery.8f4f6131.jpg";